import { messagesSelector } from '../../selectors/messagesSelectors';
import { useAppSelector } from '../../store/hooks';
import styles from './PopUp.module.css';

export const PopUp = () => {
  const { messages } = useAppSelector(messagesSelector.messages);

  return (
    <div className={styles.container}>
      {messages.map((message) => (
        <div
          key={message.id}
          className={`${styles.message} ${message.variant ? styles[message.variant] : ''}`}
        >
          {message.text}
        </div>
      ))}
    </div>
  );
};
